import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatFormFieldAppearance } from '@angular/material/form-field';

@Component({
    selector: 'usimweb-input',
    template: `
    <mat-form-field [appearance]="appearance" [style.width.%]="fullWidth ? 100 : null">
      <mat-label *ngIf="label">{{ label }}</mat-label>
      <input matInput style="font-size:14px" [placeholder]="placeholder" [(ngModel)]="value" [readonly]="readonly" [required]="required" (input)="change($event)" [disabled]="disabled" />
      <usimweb-icon *ngIf="icon" style="font-size: 22px !important;margin-bottom: 5px;margin-right: 15px;" [icon]="'search'" matPrefix></usimweb-icon>
      <mat-error *ngIf="error">
        {{ errorMsg }}
      </mat-error>
    </mat-form-field>
  `,
    standalone: false
})
export class InputComponent {
  @Input() value: any = '';
  @Input() label: string = '';
  @Input() placeholder!: any;
  @Input() readonly: boolean = false;
  @Input() fullWidth: boolean = true;
  @Input() icon: boolean = false;
  @Input() error!: boolean | string;
  @Input() errorMsg!: string;
  @Input() appearance!: MatFormFieldAppearance;
  @Input() required: boolean = false;
  @Input() disabled: boolean = false;

  @Output() valueChange = new EventEmitter<any>();

  change(event: any) {
    this.value = event.target.value;
    this.valueChange.emit(this.value);
  }
}
